'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.Consumer = exports.ConsumesUsageTrackerContext = exports.propType = undefined;

var _react = require('react');

var _consumerDecoratorFactory = require('./consumerDecoratorFactory');

var _consumerDecoratorFactory2 = _interopRequireDefault(_consumerDecoratorFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propType = exports.propType = _react.PropTypes.shape({
  track: _react.PropTypes.func.isRequired,
  clone: _react.PropTypes.func,
  setProperties: _react.PropTypes.func
});

var _createContext = (0, _react.createContext)(),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

var ConsumesUsageTrackerContext = exports.ConsumesUsageTrackerContext = (0, _consumerDecoratorFactory2.default)('usageTracker', Consumer, 'usageTracker');

exports.Consumer = Consumer;
exports.Provider = Provider;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/context/UsageTrackerContext.js
// module id = 625
// module chunks = 3 4